export const FREQUENCIES = [
    { value: 'oncePerUser', label: 'פעם אחת לכל משתמש' },
    { value: 'everySessionStart', label: 'כל פעם שמשתמש מתחבר' },
]

export function formatFrequency(frequency) {
    return FREQUENCIES.find(({ value }) => value === frequency)?.label ?? ''
}
